<div class="modal-header">
    <h4 class="modal-title">Editar Gasto</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12 mb-3">
                <label for="tipo_gasto_id">Tipo</label>
                <ng-select formControlName="tipo_gasto_id" [(ngModel)]="selected"
                    [ngClass]="{'is-invalid': form.controls['tipo_gasto_id'].errors && form.controls['tipo_gasto_id'].touched}">
                    <ng-option *ngFor="let car of select_Tgastos" [value]="car.id">{{car.nombre}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 mb-3">
                <label for="fecha">Fecha</label>
                <input class="form-control" type="date" formControlName="fecha"
                [ngClass]="{'is-invalid': form.controls['fecha'].errors && form.controls['fecha'].touched}">
            </div>
            <div class="col-12 col-sm-6 mb-3">
                <label for="fecha">Monto</label>
                <input class="form-control" type="text" formControlName="monto" (keypress)="formatter.validatePositiveNumber($event)" thousandSeparator="." mask="separator.0">
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <label for="detalle">Detalle</label><label class="campo-opcional">(Opcional)</label>
                <textarea class="form-control" type="text" formControlName="detalle" type="text"></textarea>
            </div>
        </div>
        

    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Actualizar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Cerrar</button>
</div>